// extracted by mini-css-extract-plugin
export var aniSpin = "K_d";
export var back__link = "K_bT";
export var content = "K_w";
export var el = "K_b";
export var headOffset = "K_bH";
export var heading = "K_T";
export var icon = "K_S";
export var icon__container = "K_bJ";
export var icon__inner = "K_bL";
export var icon__sizer = "K_bK";
export var image = "K_t";
export var image__bg = "K_bM";
export var image__inner = "K_bN";
export var image__sizer = "K_bP";
export var intro = "K_bc";
export var text = "K_bs";
export var text__main = "K_bR";
export var text__main__heading = "K_bS";
export var text__side = "K_bQ";
export var thumbs = "K_p";
export var thumbs__item = "K_bV";